import React from 'react';

export const SectionContainer = ({ children }) => {
    return (
        <div className="h-full w-full">
            {children}
        </div>

    )
}